/* global I18n */

import ShoppingCart from './shopping_cart'
import WebsiteConfigs from '../../website_configs/website_configs'
import ShippingAddress from './shipping_address'
import CheckoutForm from './checkout_form'
import PaypalCheckoutForm from './paypal_checkout_form'
import DynamicModal from 'modals/scripts/dynamic_modal'
import OrderItemsStore from './order_items_store'
import { checkout as stripeCheckout } from './stripe'

const SHOPPING_CART_CHECKOUT_MODAL_SELECTOR = '#shopping_cart_checkout_modal'

class Wizard {
  static render ($parent) {
    const wizard = new Wizard($parent)
    wizard.render()
  }

  static isSimpleBuyNow () {
    const shippoIntegration = $('[data-shippo]').data('shippo')
    return WebsiteConfigs.webshopType === 'buy_now' && !shippoIntegration
  }

  constructor ($parent) {
    const shippoIntegration = $('[data-shippo]').data('shippo')
    this.requireShippingDetails = !!shippoIntegration
    this.buyNowWebshopType = WebsiteConfigs.webshopType === 'buy_now'
    this.allowOffer = WebsiteConfigs.allowOffer
    this.isPayPal = $('[data-paypal-key]').data('paypal-key')
    this.isStripe = $('[data-stripe]').data('stripe')
    this.$parent = $parent
  }

  render () {
    if (this.buyNowWebshopType && this.requireShippingDetails) {
      this._renderShippingDetails({ showBack: false })
    } else if (this.buyNowWebshopType) {
      console.error('Invalid case: buy_now without shipping details')
    } else {
      this._renderShoppingCart()
    }
  }

  _renderShippingDetails (options = { showBack: false }) {
    const component = new ShippingAddress(this.$parent)
    component.showBack = options.showBack
    component.onBack = () => this._renderShoppingCart()
    component.onNext = (address) => {
      stripeCheckout(address).catch((error) => {
        component.renderError(error)
      })
    }
    component.render()
  }

  _renderShoppingCart () {
    const component = new ShoppingCart(this.$parent)
    component.showBack = true
    component.onMakeOffer = () => this._renderMakeOffer()
    component.onBack = () => this.close()
    component.onNext = () => {
      if (this.requireShippingDetails) {
        this._renderShippingDetails({ showBack: true })
      } else {
        if (this.isPayPal) {
          this.showPayPalForm()
        } else if (this.isStripe) {
          stripeCheckout().catch((error) => {
            component.renderError(error)
          })
        } else {
          this._renderSubmitOrderForm()
        }
      }
    }
    component.render()
  }

  close () {
    this.$parent.closest('.modal').modal('hide')
  }

  _renderMakeOffer () {
    const component = new CheckoutForm(this.$parent, { withOffer: true, totalPrice: this.totalPrice() })
    component.showBack = true
    component.onBack = () => this._renderShoppingCart()
    component.onNext = () => this.close()
    component.render()
  }

  totalPrice = () => {
    return OrderItemsStore.getTotalPriceData()
  }

  showPayPalForm = () => {
    this.$parent.closest('.modal').modal('hide')
    const modal = new DynamicModal(SHOPPING_CART_CHECKOUT_MODAL_SELECTOR, { size: 'lg' })
    PaypalCheckoutForm.render(modal.$body)
    modal.open()
  }

  _renderSubmitOrderForm = () => {
    const component = new CheckoutForm(this.$parent)
    component.showBack = true
    component.onBack = () => this._renderShoppingCart()
    component.onNext = () => this.close()
    component.render()
  }
}

export default Wizard
